import styled from 'styled-components'
import { ResponsiveSpaceScaleValue } from '../../styles/stylePropTypes'
import Box, { BoxProps } from './Box'

// A spacer component takes all the props a Box does, and adds the "space" prop
export type Props = BoxProps & {
  space?: ResponsiveSpaceScaleValue
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Not useful to debug type mismatch
  ref?: any
}

/**
 * A Box extension for laying out child components (of any type, not just Boxes) on top of each
 * other, with consistent spacing in between, and not having to manually remove margin from the last
 * child.
 */
const Stack = styled(Box).attrs<Props>(props => ({
  display: 'flex',
  flexDirection: 'column',
  gap: props.space,
}))<Props>``

export default Stack
